// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { z } from 'zod';

export const paymentTermSchema = z.object({
  id: z.string(),
  key: z.string(),
  label: z.string(),
  value: z.string(),
  netDays: z.number().nullable(),
});

export type PaymentTerm = z.infer<typeof paymentTermSchema>;
